import { z } from 'zod'

/**
 * The shared password policy. Both the accept-invite form and the API validate
 * against this same schema, so the client can never submit a password the
 * server would reject (or vice versa).
 *
 * The policy is length-first and deliberately has no character-class rules,
 * following NIST SP 800-63B: a long passphrase beats a short password with a
 * symbol bolted on, and composition rules push users toward predictable
 * substitutions. The max length exists only to bound argon2's work — argon2
 * has no 72-byte truncation issue like bcrypt, but an unbounded input is a
 * cheap way to burn CPU.
 */
export const PASSWORD_MIN_LENGTH = 12
export const PASSWORD_MAX_LENGTH = 200

export const passwordSchema = z
  .string()
  .min(
    PASSWORD_MIN_LENGTH,
    `Password must be at least ${PASSWORD_MIN_LENGTH} characters`,
  )
  .max(
    PASSWORD_MAX_LENGTH,
    `Password must be at most ${PASSWORD_MAX_LENGTH} characters`,
  )
